import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { UserManagementRowData } from './UserManagementRow';
import { ColumnDef } from '@tanstack/react-table';

export const USER_MANAGEMENT_TABLE_COLUMN_CLASSES = {
  name: 'min-w-0 w-auto',
  department: 'min-w-0 w-auto',
  role: 'w-[200px] min-w-[200px] max-w-[200px] overflow-hidden',
  lastActive: 'min-w-0 w-auto',
  actions: 'w-[72px] min-w-[72px] max-w-[72px] text-right',
} as const;

export type UserManagementTableColumnId = keyof typeof USER_MANAGEMENT_TABLE_COLUMN_CLASSES;

export const getUserManagementColumnClass = (columnId: string): string =>
  columnId in USER_MANAGEMENT_TABLE_COLUMN_CLASSES
    ? USER_MANAGEMENT_TABLE_COLUMN_CLASSES[columnId as UserManagementTableColumnId]
    : '';

export const useUserManagementColumns = (): ColumnDef<UserManagementRowData>[] => {
  const { t } = useTranslation('settings');
  return useMemo(
    () =>
      [
        {
          accessorKey: 'name',
          enableSorting: false,
          cell: info => info.getValue() as string,
          header: t('columns.name'),
        },
        {
          accessorKey: 'department',
          enableSorting: false,
          cell: info => info.getValue() as string,
          header: t('columns.department'),
        },
        {
          accessorKey: 'role',
          header: t('columns.role'),
          enableSorting: false,
          cell: info => info.getValue() as string,
        },
        {
          accessorKey: 'lastActive',
          header: t('columns.active'),
          enableSorting: false,
          cell: info => info.getValue() as string,
        },
        {
          id: 'actions',
          header: '',
          enableSorting: false,
          cell: () => null,
        },
      ] as ColumnDef<UserManagementRowData>[],
    [t]
  );
};
